import { useEffect, useState } from "react";
import { Bookmark, Check } from "lucide-react";
import { toast } from "sonner";
import { savedValues, addValue } from "../../lib/saved";

const changed = (el) => el.closest(".lw-editable")?.dispatchEvent(new Event("input", { bubbles: true }));

export const FieldPicker = () => {
  const [el, setEl] = useState(null);
  const [, bump] = useState(0);
  useEffect(() => {
    const down = (e) => {
      if (e.target.closest?.("[data-field-picker]")) return;
      const f = e.target.closest?.(".lw-editable .fill-field");
      setEl(f || null);
    };
    const key = (e) => e.key === "Escape" && setEl(null);
    const typed = () => bump((n) => n + 1);
    document.addEventListener("mousedown", down);
    document.addEventListener("keydown", key);
    document.addEventListener("input", typed, true);
    return () => { document.removeEventListener("mousedown", down); document.removeEventListener("keydown", key); document.removeEventListener("input", typed, true); };
  }, []);
  if (!el || !document.contains(el)) return null;
  const label = el.dataset.label || "Field";
  const values = savedValues()[label] || [];
  const cur = el.textContent.trim();
  const r = el.getBoundingClientRect();
  const pick = (v) => { el.textContent = v; changed(el); setEl(null); };
  const save = () => { const v = el.textContent.trim(); if (addValue(label, v)) toast.success(`Saved “${v}” for ${label}`); bump((n) => n + 1); };
  return (
    <div data-field-picker className="fixed z-50 w-60 rounded-lg border bg-popover text-popover-foreground shadow-lg p-1 text-sm"
      style={{ top: Math.min(r.bottom + 4, window.innerHeight - 220), left: Math.min(r.left, window.innerWidth - 248) }} data-testid="field-picker">
      <div className="px-2 py-1 text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
      {values.map((v) => (
        <button key={v} type="button" onClick={() => pick(v)} className="w-full text-left rounded px-2 py-1.5 hover:bg-accent flex items-center gap-2 truncate" data-testid="field-picker-option">
          {v === cur ? <Check className="h-3.5 w-3.5 text-primary shrink-0" /> : <span className="w-3.5" />}<span className="truncate">{v}</span>
        </button>
      ))}
      {!values.length && <div className="px-2 py-1.5 text-xs text-muted-foreground">No saved values yet. Type a value, then save it.</div>}
      {cur && !values.includes(cur) && (
        <button type="button" onClick={save} className="w-full text-left rounded px-2 py-1.5 hover:bg-accent flex items-center gap-2 border-t mt-1 text-primary" data-testid="field-picker-save">
          <Bookmark className="h-3.5 w-3.5 shrink-0" /><span className="truncate">Save “{cur}”</span>
        </button>
      )}
    </div>
  );
};
